import { useEffect } from 'react';
import type { ScheduledStem } from '../../bufferTransport';

export function useScheduledGainSync(bufferModeRef: React.MutableRefObject<boolean>, scheduledRef: React.MutableRefObject<Record<string, ScheduledStem> | null>, getEffectiveGain: (role: string) => number, deps: any[]) {
  useEffect(() => {
    if (!bufferModeRef.current || !scheduledRef.current) return;
    const sched = scheduledRef.current;
    for (const role of Object.keys(sched)) {
      try { sched[role].gain.gain.value = Math.max(0, getEffectiveGain(role)); } catch {}
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
